import React from "react";
import { accreditationsData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import "./homeSections.css";

// "Accreditations and Ratings" — content from
// src/data/home/accreditations.json.
const Accreditations = ({ data }) => {
  const { heading, badges, logos } = data || accreditationsData;
  // Repeat the (small) logo set so the marquee fills the row, then duplicate
  // the whole sequence so the -50% scroll loops seamlessly.
  const base = logos.length < 9 ? [...logos, ...logos, ...logos] : logos;
  const loop = [...base, ...base];

  return (
    <section className="accreditations-section" aria-labelledby="accreditations-title">
      <div className="container">
        <div className="accreditations-card">
          {/* <div className="accreditations-badges">
            {badges.map((text, i) => (
              <span
                key={i}
                className={`accreditation-badge${i === badges.length - 1 ? " accreditation-badge--accent" : ""}`}
              >
                {text}
              </span>
            ))}
          </div> */}

          <h2 id="accreditations-title" className="accreditations-title">{heading}</h2>

          <div className="accreditations-marquee">
            <div className="accreditations-track">
              {loop.map((src, i) => (
                <div className="accreditation-logo" key={i}>
                  <img src={mediaUrl(src)} alt="Accreditation logo" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accreditations;
